import { Component, Method, Prop, State, h } from '@stencil/core';

@Component({
  tag: 'image-capture-delete-popup',
  styleUrl: 'image-capture-delete-popup.css',
})
export class ImageCaptureDeletePopup {
  @Prop() whenClickedDelete: () => void = () => {};
  @State() isDeleting: boolean = false;

  private modal: HTMLIcoModalElement;

  @Method()
  async open() {
    this.modal.open();
  }

  @Method()
  async close() {
    this.modal.close();
  }

  onDelete = async () => {
    this.isDeleting = true;
    await this.whenClickedDelete();
    this.close();
    this.isDeleting = false;
  };

  render() {
    return (
      <ico-modal ref={(el) => (this.modal = el)} id="image-capture-delete-modal" displayX>
        <h1 slot="header" class="font-montserrat text-2xl font-bold" data-testid="imageCaptureDeletePopupHeader">
          Delete Photo
        </h1>
        <div class="mb-2" slot="main" data-testid="imageCaptureDeletePopupContent">
          Are you sure you want to delete this photo?
        </div>
        <div slot="footer" class="flex justify-between gap-x-5">
          <ico-button label="Cancel" buttonSize="large" buttonStyle="tertiary" whenClicked={() => this.close()} data-testid="imageCaptureDeletePopupCancel" />
          <ico-button label="Delete" buttonSize="large" whenClicked={this.onDelete} disabled={this.isDeleting} data-testid="imageCaptureDeletePopupConfirm" />
        </div>
      </ico-modal>
    );
  }
}
